module.exports = __webpack_public_path__ + "img/faq-poly1.2557e6d5.svg";